import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const STALE_TIME = 2 * 60 * 1000;
const CACHE_TIME = 5 * 60 * 1000;

/**
 * Monthly inventory roll-forward for the master/DAO store.
 * Backend: GET /api/analytics/stock-snapshot?year=&month=
 * → { year, month, store_id, opening:{items}, purchases:{items},
 *     closing:{items}, movement:{ opening, added, sold, closing } }
 */
export const useStockSnapshot = (year, month) => {
  return useQuery({
    queryKey: ["stock-snapshot", year, month],
    queryFn: async () => {
      const { data } = await axios.get("/api/analytics/stock-snapshot", {
        params: { year, month },
        metadata: { silent: true }, // access is gated by the page; don't toast 403s
      });
      return data;
    },
    staleTime: STALE_TIME,
    cacheTime: CACHE_TIME,
    keepPreviousData: true,
  });
};

/** Toggle the persisted verified sign-off for the period. Returns { verified }. */
export const toggleStockVerified = async (year, month) =>
  (await axios.post("/api/analytics/stock-snapshot/verify", null, { params: { year, month } })).data;
